var map = {
	"./account-ico-mail.svg": 809,
	"./account-ico-pass.svg": 810,
	"./account-ico-phone.svg": 811,
	"./bank-transfer.svg": 812,
	"./betnearn-ico.svg": 813,
	"./birthday-bonus-ico.svg": 814,
	"./bonus-code-ico.svg": 815,
	"./bonus-ico.svg": 816,
	"./bonus-received-ico.svg": 817,
	"./business-account-upgrade-ico.svg": 818,
	"./check-in-daily-ico.svg": 819,
	"./checked.svg": 820,
	"./cloud-pointer.svg": 821,
	"./crypto.svg": 822,
	"./daily-bonus-ico.svg": 823,
	"./deposit-delay-bonus-ico.svg": 824,
	"./e-wallet.svg": 825,
	"./earn-coin-ico.svg": 826,
	"./earn-x33-coin-ico.svg": 827,
	"./email.svg": 828,
	"./facebook.svg": 829,
	"./feedback.svg": 830,
	"./first-bet-ico.svg": 831,
	"./games-rebate-ico.svg": 832,
	"./info.svg": 833,
	"./instagram.svg": 834,
	"./instant-rebate.svg": 835,
	"./live-casino-rebate-ico.svg": 836,
	"./lucky-spin-ico.svg": 837,
	"./messenger.svg": 838,
	"./mobile-app-deposit-ico.svg": 839,
	"./msg-activity.svg": 840,
	"./msg-ann.svg": 841,
	"./msg-notice.svg": 842,
	"./new-icon.svg": 843,
	"./people-ico.svg": 844,
	"./quick-pay.svg": 845,
	"./r77-coin.svg": 846,
	"./rescue-bonus-ico.svg": 847,
	"./rescue-lc-ico.svg": 848,
	"./rescue-slots-ico.svg": 849,
	"./return.svg": 850,
	"./sc-bc-active-ico.svg": 851,
	"./sc-bc-ico.svg": 852,
	"./sc-bi-active-ico.svg": 853,
	"./sc-bi-ico.svg": 854,
	"./sc-mail-active-ico.svg": 855,
	"./sc-mail-ico.svg": 856,
	"./sc-mp-active-ico.svg": 857,
	"./sc-mp-ico.svg": 858,
	"./sc-pin-active-ico.svg": 859,
	"./sc-pin-ico.svg": 860,
	"./slots-rebate-ico.svg": 861,
	"./sports-rebate-ico.svg": 862,
	"./telegram.svg": 863,
	"./twitter.svg": 864,
	"./vip-up-level-ico.svg": 865,
	"./vip-weekly-bonus.svg": 866,
	"./wallet-ico.svg": 867,
	"./weekly-tournament-ico.svg": 868,
	"./welcome-bonus-ico.svg": 869,
	"./whatsapp.svg": 870,
	"./withdrawal-delay-bonus-ico.svg": 871,
	"./x33-coin.svg": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;